import { HumanType } from "../feature";

export const isHumanType = (object: unknown): object is HumanType => {
  if (object !== null && typeof object === "object") {
    return "name" in object && "dateOfBirth" in object && "sex" in object && "school" in object && "emergencyContact" in object;
  }
  return false;
}
